import React from 'react'

export default function UploadsEmpty() {
  return (
    <div className="card card-empty mb-4">
      <div className="card-body">
        <p><strong>No uploads to display.</strong></p>

        <p>Uploads provide a way to build a library of photos, head shots, logos, and video clips that can easily be re-used across templates when creating graphics.</p>
      </div>
    </div>
  )
}
